module.exports = __webpack_public_path__ + "img/edx.d20ac939.svg";